import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { FaComment, FaPeriscope, FaPhone } from 'react-icons/fa';
import '../css/Contact.css'
import emailjs from 'emailjs-com'
// import axios from "axios"   // npm install axios

const Contact = () => {

    const [contact, setcontact] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        msg: '',
    })


    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const name = document.getElementById("name")
    const email = document.getElementById("email")
    const phone = document.getElementById("phone")
    const subject = document.getElementById("subject")
    const msg = document.getElementById("msg")

    const sendemail = (e) => {
        e.preventDefault()
        //    console.log(contact)
        emailjs.send('service_ezhiu0n', 'template_oeqijib', contact, '2qpDFNj5nca4ER44Z')
            .then((res) => {
                alert("Your Email is recieved successfully, Our team will contact on your provided contact infromation.")
                document.getElementById('contactformits').reset()
            }, (err) => {
                alert("Failed to send your email.")
            })
    }

    return (
        <div>
            <div className="abouth drugupperjpg contbgposition" >
                <h1>Contact Us</h1>
            </div >
            <div className="cobe">
                <form id="contactformits" className="contactforminmaxwith" onSubmit={sendemail}>
                    <div className="flex" >
                        <div className="lfl" >
                            <div className="inputcon" >
                                <h4>Name</h4>
                                <input placeholder="NAME" type='text' id="name" required onChange={e => { setcontact(ps => { return { ...ps, name: e.target.value } }) }} />
                            </div>
                            <div className="inputcon" >
                                <h4>Email</h4>
                                <input placeholder="EMAIL" type='text' id="email" required onChange={e => { setcontact(ps => { return { ...ps, email: e.target.value } }) }} />
                            </div>
                            <div className="inputcon" >
                                <h4>Your Phone</h4>
                                <input placeholder="PHONE" type='text' id="phone" required onChange={e => { setcontact(ps => { return { ...ps, phone: e.target.value } }) }} />
                            </div>
                            <div className="inputcon" >
                                <h4>Subject</h4>
                                <input placeholder="SUBJECT" type='text' id="subject" required onChange={e => { setcontact(ps => { return { ...ps, subject: e.target.value } }) }} />
                            </div>
                        </div>
                        <div className="rfl" >
                            <div className="ricon" >
                                <a href="#" className="rline">
                                    <div className="iconstyle" ><FaComment color="white" /></div>
                                    <div className="sideicon">  Almakkahjalihouse@gamil.com</div>
                                </a>
                                <a href="#" className="rline">
                                    <div className="iconstyle" ><FaPeriscope color="white" /></div>
                                    <div className="sideicon">  25.No Road, Shahdra Lahore Pakistan</div>
                                </a>
                                <a href="#" className="rline">
                                    <div className="iconstyle" ><FaPeriscope color="white" /></div>
                                    <div className="sideicon">  2nd Branth Road Lahore</div>
                                </a>
                                <a href="#" className="rline">
                                    <div className="iconstyle" ><FaPhone color="white" /></div>
                                    <div className="sideicon">	+92 341 752 2886</div>
                                </a>


                            </div>
                        </div>
                    </div>
                    <div className="inputcon" >
                        <h4>Your Message</h4>
                        <textarea placeholder="YOUR MESSAGE" className="textarea" id="msg" required onChange={e => { setcontact(ps => { return { ...ps, msg: e.target.value } }) }} />
                    </div>
                    <div className="actioncon"><input type="submit" value="GET ACTION" className="gabtn" /></div>
                </form>
            </div>
            <div className="cmap" >
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27176.35644106045!2d74.24236953944431!3d31.63263044068815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39191d52010f1ad1%3A0xe2877f27d0d00853!2sAl%20-makkah%20fancing%20house!5e0!3m2!1sen!2s!4v1651146757135!5m2!1sen!2s" width="100%" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>

    )
}
export default Contact;